import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { addCommission, removeCommission } from 'bundles/apex/deals/form/store/deal/actions';

import Collection from 'bundles/apex/deals/form/fields/collection';
import Broker from './broker';
import DealField from 'bundles/apex/deals/form/fields/field';
import { filterCommissions } from 'bundles/backoffice/vouchers/helpers/commissions';

export function OutsideBrokers({ addCommission, deal, removeCommission, required, transactionSide }) {
  const commissions = filterCommissions(deal.commissions, transactionSide, true);

  function clear() {
    removeCommission(commissions[0]);
    addCommission({ outside: true, transactionSide });
  }

  return (
    <Collection
      addLabel="Add Broker"
      hasValue={!!commissions[0]?.contact}
      onAdd={() => addCommission({ outside: true, transactionSide })}
      onClear={clear}
      onRemoveIndex={index => removeCommission(commissions[index])}
    >
      {commissions.map(commission => (
        <Broker
          commission={commission}
          key={commission.id || commission.localId}
          removable={!commission.id || !deal.voucher}
          required={required}
          transactionSide={transactionSide}
        />
      ))}
    </Collection>
  );
}

OutsideBrokers.propTypes = {
  addCommission: PropTypes.func,
  deal: PropTypes.shape({
    commissions: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      localId: PropTypes.string,
      outside: PropTypes.bool,
    })).isRequired,
    voucher: PropTypes.object,
  }),
  removeCommission: PropTypes.func.isRequired,
  required: PropTypes.bool,
  transactionSide: PropTypes.string,
};

const mapDispatchToProps = {
  addCommission,
  removeCommission,
};

export default connect(null, mapDispatchToProps)(DealField(OutsideBrokers, 'outsideBrokers'));
